import React from "react";
import { Helmet } from "react-helmet";
import { appRoutes } from "../routes";
import { Link } from "react-router-dom";
import './sitemap.css';
import Header from '../master_root/header';
export default function Sitemap() {

  const excludedPaths = ["/sitemap", "/account"];

  const visibleRoutes = appRoutes.filter(route => !excludedPaths.includes(route.path));

  return (
        <div >
           <Header /> 
         <div className='app_header_height'></div>
    <div className="container_roots">
    <Helmet>
  <title>Sitemap | EditorTask - Explore All Job & Creative Pages</title>
  <meta
    name="description"
    content="Navigate through all EditorTask pages including job listings, freelancer profiles, creative portfolios, app features, and more. Easily find what you need with our sitemap."
  />
  <meta
    name="keywords"
    content="EditorTask Sitemap, Job Portal Pages, Freelance Talent Navigation, Hire Editors, Creative Portfolios, Task Marketplace, Editor Pages"
  />
  <meta name="robots" content="index, follow" />
  <meta name="author" content="editortask.com" />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Sitemap | EditorTask - Explore All Job & Creative Pages"
  />
  <meta
    property="og:description"
    content="Easily explore EditorTask’s platform including freelance opportunities, editor profiles, and creative tools. Your sitemap to everything creative."
  />
  <meta
    property="og:image"
    content="https://www.editortask.com/editortask_logo.png"
  />
  <meta property="og:url" content="https://www.editortask.com/sitemap" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="EditorTask" />

  
</Helmet>


      <div className="container_size">
  <h2 className="features-heading">Explore All Pages</h2>
  <p className="features-subtitle">Browse all the available pages of our website</p>

  <div className="features-grid">
    {visibleRoutes.map((route, index) => (
      <Link to={route.path} className="feature-card" key={index}>
        <div className="feature-icon">🔗</div> {/* optional icon */}
        <div className="feature-title">{route.name}</div>
        <div className="feature-desc">{route.description || 'Click to explore this page.'}</div>
      </Link>
    ))}
  </div>
</div>
    </div>
    </div>
  );
}
